/**
 * 在线网站服务
 * 处理在线导航分类和网站数据的API调用
 */
import { get } from './apiClient';

/**
 * 获取所有在线导航分类
 * @returns {Promise} 分类列表
 */
export const fetchOnlineCategories = async () => {
  try {
    const response = await get('/online-nav');
    
    // 转换后端数据格式为前端需要的格式
    const categories = response.data.map(category => ({
      id: category.id,
      text: category.text,
      icon: category.icon.replace('fas fa-', '') // 移除FontAwesome前缀，只保留图标名
    }));
    
    // 添加"全部"选项
    return [
      { id: 'all', text: '全部', icon: 'th-large' },
      ...categories
    ];
  } catch (error) {
    console.error('获取在线分类失败:', error);
    throw new Error('获取分类失败，请重试');
  }
};

/**
 * 根据分类ID获取网站数据
 * @param {string} categoryId 分类ID
 * @param {number} page 页数，默认1
 * @param {number} limit 每页数量，默认50
 * @returns {Promise} 网站数据
 */
export const fetchOnlineWebsitesByCategory = async (categoryId, page = 1, limit = 50) => {
  try {
    // 如果是"全部"分类，需要获取所有分类的数据
    if (categoryId === 'all') {
      // 先获取所有分类
      const categoriesResponse = await get('/online-nav');
      const categories = categoriesResponse.data;
      
      // 并行获取所有分类的网站数据
      const websitePromises = categories.map(category => 
        get(`/online-nav/${category.id}/websites?page=1&limit=1000`) // 获取大量数据
      );
      
      const websiteResponses = await Promise.all(websitePromises);
      
      // 合并所有网站数据
      const allWebsites = websiteResponses.flatMap(response => response.data || []);
      
      return allWebsites.map(transformWebsiteData);
    } else {
      // 获取特定分类的网站数据
      const response = await get(`/online-nav/${categoryId}/websites?page=${page}&limit=${limit}`);
      const result = (response.data || []).map(transformWebsiteData)
      return result;
    }
  } catch (error) {
    console.error('获取在线网站数据失败:', error);
    throw new Error('网络请求失败，请重试');
  }
};

/**
 * 转换后端网站数据格式为前端需要的格式
 * @param {Object} website 后端网站数据
 * @returns {Object} 前端格式的网站数据
 */
const transformWebsiteData = (website) => {
  return {
    id: website.id,
    name: website.name,
    description: website.description || '',
    url: website.url,
    ico: website.ico || website.iconUrl || '',
    iconUrl: website.iconUrl || website.ico || '',
    textIcon: website.textIcon || website.name?.substring(0, 2) || '',
    bgColor: website.bgColor || website.iconColor || '#1890ff',
    iconColor: website.iconColor || '#000000',
    dataType:website.dataType || 0,
    preferredIconType: website.preferredIconType || ((website.ico || website.iconUrl) ? '1' : '2')
  };
};

export default {
  fetchOnlineCategories,
  fetchOnlineWebsitesByCategory
}; 